(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Cust_img-text_tab"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const tabTitles = document.querySelectorAll(".tab_titles .tab_title");
        const tabContents = document.querySelectorAll(".tab_contents .tab_content");

        if (!tabTitles.length || !tabContents.length) return;

        // Set first tab active by default
        tabTitles[0].classList.add("active");
        tabContents[0].classList.add("active");

        tabTitles.forEach((tab, index) => {
            tab.addEventListener("click", () => {
                // Remove active class from all
                tabTitles.forEach(t => t.classList.remove("active"));
                tabContents.forEach(c => c.classList.remove("active"));

                // Add active class to clicked tab and matching content
                tab.classList.add("active");
                tabContents[index].classList.add("active");
            });
        });
    });



document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.querySelector('.book-appointment-popup-open');
    const closeBtn = document.querySelector('.book-appointment-popup-close');
    const targetSec = document.querySelector('.bookapper-sec');

    if (openBtn && targetSec) {
        openBtn.addEventListener('click', function () {
            targetSec.classList.add('active');
        });
    }

    if (closeBtn && targetSec) {
        closeBtn.addEventListener('click', function () {
            targetSec.classList.remove('active');
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Adding class based on megamenu open
  if (window.innerWidth >= 990) {
    const headerDiv = document.querySelector(".header");
    const menuItems = document.querySelectorAll(".header__inline-menu .mega-menu");

    menuItems.forEach((menuItem) => {
      menuItem.addEventListener("toggle", () => {
        if (menuItem.hasAttribute("open")) {
          headerDiv.classList.add("menu-open");
        } else {
          headerDiv.classList.remove("menu-open");
        }
      });
    });
  }
  // Adding class based on megamenu open

  } catch(e) { console.error(e); }
})();
})();
